"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8890],{

/***/ 68890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ masonry_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 1 modules
var asset_component = __webpack_require__(49738);
// EXTERNAL MODULE: ./segments/desktop/core-components/window-mask/window-mask.js + 2 modules
var window_mask = __webpack_require__(26718);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/masonry-grid/default-props.js
var MASONRY_IMAGE_ASSETS = {
    TIMELINE_COLUMN: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Timeline_column.jpg",
        alt: "Timeline column"
    },
    STATUS_COLUMN: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Status_column.jpg",
        alt: "Status column"
    },
    BATTERY: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Battery.jpg",
        alt: "Task progress"
    },
    INTEGRATION: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Integration.jpg",
        alt: "Integration"
    },
    PIE: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Pie.jpg",
        alt: "Pie widget"
    },
    MOBILE: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/MobileApp.jpg",
        alt: "Mobile phone with project management board"
    },
    AUTOMATION: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Automation.jpg",
        alt: "Automation"
    },
    COMMENT: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Talk.jpg",
        alt: "Comment"
    },
    DASHBOARD: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Dash.jpg",
        alt: "Dashboard"
    }
};
var MASONRY_VIDEO_ASSETS = {
    TIMELINE_COLUMN: {
        src: {
            formats: [
                "/Generator_featured images/Home Page - 2022 Rebrand/Masonry/final/Timeline_column.mp4"
            ]
        },
        alt: "Timeline column",
        playWhenVisible: false,
        autoPlay: false,
        loop: false,
        poster: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Timeline_column.jpg",
        startAfter: "500"
    },
    STATUS_COLUMN: {
        src: {
            formats: [
                "/Generator_featured images/Home Page - 2022 Rebrand/Masonry/final/Status_column.mp4"
            ]
        },
        alt: "Status column",
        playWhenVisible: false,
        autoPlay: false,
        loop: false,
        poster: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Status_column.jpg",
        startAfter: "2000"
    },
    BATTERY: {
        src: {
            formats: [
                "/Generator_featured images/Home Page - 2022 Rebrand/Masonry/final/Battery.mp4"
            ]
        },
        alt: "Battery widget",
        playWhenVisible: false,
        autoPlay: false,
        loop: false,
        poster: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Battery.jpg",
        startAfter: "16000"
    },
    INTEGRATION: {
        src: {
            formats: [
                "/Generator_featured images/Home Page - 2022 Rebrand/Masonry/final/Integration.mp4"
            ]
        },
        alt: "Integration",
        playWhenVisible: false,
        autoPlay: false,
        loop: false,
        poster: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Integration.jpg",
        startAfter: "7000"
    },
    PIE: {
        src: {
            formats: [
                "/Generator_featured images/Home Page - 2022 Rebrand/Masonry/final/Pie.mp4"
            ]
        },
        alt: "Pie widget",
        playWhenVisible: false,
        autoPlay: false,
        loop: false,
        poster: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Pie.jpg",
        startAfter: "17500"
    },
    MOBILE: {
        src: {
            formats: [
                "/Generator_featured images/Home Page - 2022 Rebrand/Masonry/final/MobileApp.mp4"
            ]
        },
        alt: "Mobile phone with project management board",
        playWhenVisible: false,
        autoPlay: false,
        loop: false,
        poster: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/MobileApp.jpg",
        startAfter: "15000"
    },
    AUTOMATION: {
        src: {
            formats: [
                "/Generator_featured images/Home Page - 2022 Rebrand/Masonry/final/Automation.mp4"
            ]
        },
        alt: "Automation",
        playWhenVisible: false,
        autoPlay: false,
        loop: false,
        poster: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Automation.jpg",
        startAfter: "9000"
    },
    COMMENT: {
        src: {
            formats: [
                "/Generator_featured images/Home Page - 2022 Rebrand/Masonry/final/Talk.mp4"
            ]
        },
        alt: "Comment",
        playWhenVisible: false,
        autoPlay: false,
        loop: false,
        poster: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Talk.jpg",
        startAfter: "11000"
    },
    DASHBOARD: {
        src: {
            formats: [
                "/Generator_featured images/Home Page - 2022 Rebrand/Masonry/final/Dash.mp4"
            ]
        },
        alt: "Dashboard",
        playWhenVisible: false,
        autoPlay: false,
        loop: false,
        poster: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Masonry/final/Dash.jpg",
        startAfter: "4000"
    }
};
/* harmony default export */ var default_props = ({
    assets: [
        {
            asset: {
                video: MASONRY_VIDEO_ASSETS.TIMELINE_COLUMN,
                image: MASONRY_IMAGE_ASSETS.TIMELINE_COLUMN
            }
        },
        {
            asset: {
                video: MASONRY_VIDEO_ASSETS.STATUS_COLUMN,
                image: MASONRY_IMAGE_ASSETS.STATUS_COLUMN
            }
        },
        {
            asset: {
                video: MASONRY_VIDEO_ASSETS.BATTERY,
                image: MASONRY_IMAGE_ASSETS.BATTERY
            }
        },
        {
            asset: {
                video: MASONRY_VIDEO_ASSETS.INTEGRATION,
                image: MASONRY_IMAGE_ASSETS.INTEGRATION
            }
        },
        {
            asset: {
                video: MASONRY_VIDEO_ASSETS.PIE,
                image: MASONRY_IMAGE_ASSETS.PIE
            }
        },
        {
            asset: {
                video: MASONRY_VIDEO_ASSETS.MOBILE,
                image: MASONRY_IMAGE_ASSETS.MOBILE
            }
        },
        {
            asset: {
                video: MASONRY_VIDEO_ASSETS.AUTOMATION,
                image: MASONRY_IMAGE_ASSETS.AUTOMATION
            }
        },
        {
            asset: {
                video: MASONRY_VIDEO_ASSETS.COMMENT,
                image: MASONRY_IMAGE_ASSETS.COMMENT
            }
        },
        {
            asset: {
                video: MASONRY_VIDEO_ASSETS.DASHBOARD,
                image: MASONRY_IMAGE_ASSETS.DASHBOARD
            }
        }
    ],
    hideControls: true,
    alignToLogo: true
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
// EXTERNAL MODULE: ./segments/desktop/header/layouts/components/basic-header/constants.js
var constants = __webpack_require__(72428);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var desktop_constants = __webpack_require__(73759);
var constants_default = /*#__PURE__*/__webpack_require__.n(desktop_constants);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/masonry-grid/masonry-grid-component.scss.js




var HEADER_LOGO_HORIZONTAL_PADDING = "".concat(constants/* default.HEADER_CONTENT_HORIZONTAL_PADDING */.Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var BODY_HORIZONTAL_PADDING = "".concat((constants_default()).BODY_CONTENT_HORIZONTAL_PADDING, "px");
var StyledMasonryGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ses6ll0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, 'px;margin:auto;.grid-container{display:grid;grid-template-areas:"column1      battery       phone   automation  comment         .    "\n        "column2      battery       phone       .           .           .    "\n        "column2      battery       phone   dashboard   dashboard   dashboard"\n        "integration  integration   phone   dashboard   dashboard   dashboard"\n        "   .         pie           phone   dashboard   dashboard   dashboard"\n        "   .            .            .     dashboard   dashboard   dashboard";grid-template-columns:12.64vw 11.54vw 14.79vw 14.72vw 12.64vw 18%;grid-template-rows:5vw 2.5vw 1.25vw 6.39vw 9.17vw auto;grid-gap:1.67vw;padding-left:', BODY_HORIZONTAL_PADDING, ";&.align-to-logo{padding-left:", HEADER_LOGO_HORIZONTAL_PADDING, ";}}.item1{grid-area:column1;}.item2{grid-area:column2;}.item3{grid-area:battery;}.item4{grid-area:integration;}.item5{grid-area:pie;}.item6{grid-area:phone;}.item7{grid-area:automation;}.item8{grid-area:comment;}.item9{grid-area:dashboard;}.item{filter:drop-shadow(-10.8923px 14.523px 35.0973px rgba(29,140,242,0.2));border-radius:8px;z-index:-1;.asset-inner{width:100%;height:auto;}img,video{border-radius:8px;}&.timeline,&.status,&.battery,&.mobile{background-color:white;}&.status{display:flex;}&.battery,&.integration,&.pie{z-index:0;}&.battery{display:inherit;.asset-inner{margin:auto;}}&.mobile{padding:7px;border-radius:24px;.asset-inner{filter:drop-shadow(-8.52044px 11.3606px 27.4548px rgba(29,140,242,0.3));}img,video{border-radius:24px;}}&.dashboard{filter:none;min-width:638.81px;.window-mask{padding:0;.video-component{height:unset;}img,video{border-top-left-radius:0;border-top-right-radius:0;}}}}@media (min-width:", vp_sizes.SM + 1, "px) and (max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px){.grid-container{grid-template-columns:182px 166.19px 213px 211.96px 182px auto;grid-template-rows:72px 36px 12px 92px 132px auto;grid-gap:24px;}}@media (max-width:", vp_sizes.SM, 'px){margin:auto;.grid-container{display:grid;grid-template-areas:"phone automation comment"\n          "phone . ."\n          "phone column1 battery"\n          "phone column2 battery"\n          "phone integration integration";grid-template-columns:33% 29% 28%;grid-template-rows:24% 2% 18% 18% 22%;grid-gap:4%;padding:10px;&.align-to-logo{padding-left:10px;}}.item{box-shadow:-10.8923px 14.523px 35.0973px rgba(29,140,242,0.2);&.dashboard{filter:none;min-width:unset;}&.mobile{padding:7px;border-radius:24px;img,video{border-radius:14px;}}&.dashboard,&.pie{display:none;}}}');

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/masonry-grid/masonry-grid-component.js

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var MasonryGridComponent = function(props) {
    var _assets_, _assets_1, _assets_2, _assets_3, _assets_4, _assets_5, _assets_6, _assets_7, _assets_8;
    var assets = props.assets, hideControls = props.hideControls, alignToLogo = props.alignToLogo;
    var ref = (0,react.useState)(false), wasComponentEverVisible = ref[0], setWasComponentEverVisible = ref[1];
    var ref1 = (0,react.useState)([]), assetTimingsProps = ref1[0], setAssetTimingsProps = ref1[1];
    var VISIBILITY_SENSOR_OFFSET = 100;
    var updateAssetTimingsProps = function(param) {
        var index = param.index;
        var _assets_index, _assets_index_asset, _assets_index1;
        var updatedAssetTimingsProps = (0,_to_consumable_array/* default */.Z)(assetTimingsProps);
        updatedAssetTimingsProps[index] = _object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_index = assets[index]) === null || _assets_index === void 0 ? void 0 : _assets_index.asset), {
            video: _object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_index1 = assets[index]) === null || _assets_index1 === void 0 ? void 0 : (_assets_index_asset = _assets_index1.asset) === null || _assets_index_asset === void 0 ? void 0 : _assets_index_asset.video), {
                autoPlay: true
            })
        });
        setAssetTimingsProps(updatedAssetTimingsProps);
    };
    (0,react.useEffect)(function() {
        if (wasComponentEverVisible) {
            assets === null || assets === void 0 ? void 0 : assets.forEach(function(param, index) {
                var asset = param.asset;
                var _asset_video;
                setTimeout(function() {
                    updateAssetTimingsProps({
                        index: index
                    });
                }, Number(asset === null || asset === void 0 ? void 0 : (_asset_video = asset.video) === null || _asset_video === void 0 ? void 0 : _asset_video.startAfter) || 0);
            });
        }
        return function() {};
    }, [
        wasComponentEverVisible
    ]);
    var onVisibilityChange = function(isVisible) {
        if (!wasComponentEverVisible && isVisible) {
            setWasComponentEverVisible(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
        offset: {
            bottom: VISIBILITY_SENSOR_OFFSET,
            top: VISIBILITY_SENSOR_OFFSET
        },
        partialVisibility: true,
        onChange: onVisibilityChange,
        active: !wasComponentEverVisible,
        scrollCheck: !wasComponentEverVisible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMasonryGridComponent, {
            className: "masonry-grid-component",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("grid-container", {
                    "align-to-logo": alignToLogo
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("item", "item1", "timeline"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_ = assets[0]) === null || _assets_ === void 0 ? void 0 : _assets_.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[0]))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("item", "item2", "status"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_1 = assets[1]) === null || _assets_1 === void 0 ? void 0 : _assets_1.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[1]))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("item", "item3", "battery"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_2 = assets[2]) === null || _assets_2 === void 0 ? void 0 : _assets_2.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[2]))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("item", "item4", "integration"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_3 = assets[3]) === null || _assets_3 === void 0 ? void 0 : _assets_3.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[3]))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("item", "item5", "pie"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_4 = assets[4]) === null || _assets_4 === void 0 ? void 0 : _assets_4.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[4]))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("item", "item6", "mobile"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_5 = assets[5]) === null || _assets_5 === void 0 ? void 0 : _assets_5.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[5]))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("item", "item7", "automation"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_6 = assets[6]) === null || _assets_6 === void 0 ? void 0 : _assets_6.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[6]))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("item", "item8", "comment"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_7 = assets[7]) === null || _assets_7 === void 0 ? void 0 : _assets_7.asset), {
                            hideControls: hideControls
                        }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[7]))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("item", "item9", "dashboard"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(window_mask/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread(_object_spread_props(_object_spread({}, assets === null || assets === void 0 ? void 0 : (_assets_8 = assets[8]) === null || _assets_8 === void 0 ? void 0 : _assets_8.asset), {
                                hideControls: hideControls
                            }), assetTimingsProps === null || assetTimingsProps === void 0 ? void 0 : assetTimingsProps[8]))
                        })
                    })
                ]
            })
        })
    });
};
MasonryGridComponent.defaultProps = default_props;
/* harmony default export */ var masonry_grid_component = (MasonryGridComponent);


/***/ })

}]);